import {AssignableUser} from '@/models/AssignableUser';

export class AssignableBLFuser {
    public id: number;
    public firstname: string;
    public lastname: string;
    public assigned: boolean;
    public blfWillBeRemoved: boolean;

    constructor(assignableUser: AssignableUser, blfWillBeRemoved: boolean) {
        this.id = assignableUser.id;
        this.firstname = assignableUser.firstname;
        this.lastname = assignableUser.lastname;
        this.assigned = assignableUser.assigned;
        this.blfWillBeRemoved = blfWillBeRemoved;
    }

}
